/**
 * 로그인 세션 저장소.
 * 파트너 API는 access 토큰 하나만 발급하고 refresh가 없다
 * (만료: dev 30일 · prod 12시간, 로그인 응답 expiresIn 초 단위).
 */

const TOKEN_KEY = 'auth-token';
const TOKEN_EXPIRES_AT_KEY = 'auth-token-expires-at';
/** zustand persist 키 — authStore와 같아야 한다 */
export const AUTH_STORAGE_KEY = 'auth-storage';

/** 하드 리다이렉트 뒤 로그인 화면에서 안내 문구를 보여 주기 위한 키 */
const SESSION_END_MESSAGE_KEY = 'auth-session-end-message';

export const saveAccessToken = (token: string, expiresInSeconds: number) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(
    TOKEN_EXPIRES_AT_KEY,
    String(Date.now() + expiresInSeconds * 1000),
  );
};

/** 만료가 지난 토큰은 없는 것으로 본다 */
export const getAccessToken = (): string | null => {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiresAt = Number(localStorage.getItem(TOKEN_EXPIRES_AT_KEY));
  if (!token || !expiresAt || Date.now() >= expiresAt) return null;
  return token;
};

export const clearAuthSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
  localStorage.removeItem(AUTH_STORAGE_KEY);
};

export const persistSessionEndMessage = (message: string) => {
  sessionStorage.setItem(SESSION_END_MESSAGE_KEY, message);
};

export const consumeSessionEndMessage = (): string | null => {
  const message = sessionStorage.getItem(SESSION_END_MESSAGE_KEY);
  sessionStorage.removeItem(SESSION_END_MESSAGE_KEY);
  return message?.trim() || null;
};
